import React from 'react';
import { costumerRoutes } from './customer.routes';
import { agentRoutes } from './agent.routes';
import { adminRoutes } from './admin.routes';
import { directorRoutes } from './director.routes';
import { IUserRole } from '../interfaces';
import { DashboardCustomer } from '../pages/DashboardCustomer/DashboardCustomer';
import { DashboardAgent } from '../pages/DashboardOffice/DashboardAgent';
import { DashboardDirector } from '../pages/DashboardDirector/DashboardDirector';

export interface RoutesDynamicReturn {
  DashboardContainerComponent: React.ComponentType;
  routes: {
    path: string;
    name: string;
    component: React.ReactNode;
  }[];
}

const routes: { [key in IUserRole]: RoutesDynamicReturn } = {
  customer: { DashboardContainerComponent: DashboardCustomer, routes: costumerRoutes },
  agent: { DashboardContainerComponent: DashboardAgent, routes: agentRoutes },
  admin: { DashboardContainerComponent: DashboardCustomer, routes: adminRoutes },
  director: { DashboardContainerComponent: DashboardDirector, routes: directorRoutes },
  shareholder: { DashboardContainerComponent: DashboardDirector, routes: directorRoutes }
};

export { routes };
